import React, { useState } from "react";
import { callApi } from "../../actions/base";
import OrderCreate from "../dashboard/OrderCreate";
import BaseOrderList from "../OrdersList";
import withOwnerOrderFilters from "./withOwnerOrderFilters";
import {HTTP_METHOD} from "../../constants/http";

const useOrdersFetch = () => {
  const [orders, setOrders] = useState([]);

  const fetchOrders = params =>
    callApi("/auth/orders", params, setOrders, console.error, HTTP_METHOD.GET);

  return {
    fetchOrders,
    orders,
  };
};

const OrdersList = props => {
  const { fetchOrders, orders } = useOrdersFetch();

  return (
    <BaseOrderList
      {...props}
      detailsUri="/dashboard/orders"
      fetchOrders={fetchOrders}
      orders={orders}
    >
      <OrderCreate />
    </BaseOrderList>
  );
};

export default withOwnerOrderFilters(OrdersList);
